import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface RouteLinkProps {
  children: ReactNode;
  to: string;
  isActive?: boolean;
}

const RouteLink = ({ children, to, isActive = false }: RouteLinkProps) => {
  return (
    <Link
      to={to}
      style={{
        fontSize: '13px',
        lineHeight: '20px',
        fontWeight: 500,
        color: isActive ? 'var(--blue-gradient-03)' : 'var(--neutral-800)',
        textDecoration: 'none',
      }}
    >
      {children}
    </Link>
  );
};

export default RouteLink;
